import React, {Component} from 'react';
import DefaultHeader from './defaultHeader';
import Main from './Main';
import './css/root.css';

class App extends Component {
  render() {
    return <div>
      <DefaultHeader/>
      <Main/>
    </div>
  }
}
export default App;



// WEBPACK FOOTER //
// ./src/app.js